import { BusinessBaseInfo } from "@/modules/types/business/business";
import { useCallback, useState } from "react";
import debounce from "lodash/debounce";
import { businessService } from "@/modules/services/businessService";
import { AppError } from "@/lib/utils/errors";

export const useSearchBusiness = () => {
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [businessSuggestions, setBusinessSuggestions] = useState<
    BusinessBaseInfo[]
  >([]);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLoading(true);
    setSearchTerm(event.target.value);
    fetchBusinessSuggestions(event.target.value);
  };

  const fetchBusinessSuggestions = useCallback(
    debounce(async (search: string) => {
      try {
        const resp = await businessService.searchCompanies({
          search,
          limit: 10, // You can adjust this limit as needed
        });

        if (resp && resp.businessInfos) {
          setBusinessSuggestions(resp.businessInfos);
        }
      } catch (err) {
        const appErr = new AppError(err);
        appErr.setAction("useSearchBusiness.fetchBusinessSuggestions");
        appErr.setApiAction("businessService.searchCompanies");
        appErr.logError();
      } finally {
        setLoading(false);
      }
    }, 300),
    []
  );

  return {
    searchBusinessTerm: searchTerm,
    handleSearchBusiness: handleSearch,
    businessSuggestions,
    loadingBusinessSuggestions: loading,
  };
};
